var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext, useState, useCallback, useMemo, useEffect, } from 'react';
import productLayoutConfigCollection, { PRODUCT_LAYOUTS, productLayoutConfigDefault, componentVisibleDefault, } from './productLayoutConfig';
// initialized with '{}' so the catch will work if not started within a Provider
var ProductLayoutContext = createContext({});
// Hook for Components - you can use the wishlist by including this
export var useProductLayout = function () {
    var context = useContext(ProductLayoutContext);
    // Check for empty context
    if (Object.keys(context).length === 0) {
        throw new Error('useProductLayout must be used within a ProductLayoutProvider');
    }
    return context;
};
/**
 * Provider - Wrap this to use useProductLayout
 * @param {ProductLayoutsCustom} [customLayouts] Object that contains your custom layouts
 * @param {ProductLayoutNameCustom} [layoutName] Preset layout that should be used within the provider. Default presets are found in the PRODUCT_LAYOUTS array
 */
var ProductLayoutProvider = function (_a) {
    var _b = _a.customLayouts, customLayouts = _b === void 0 ? {} : _b, _c = _a.layoutName, layoutName = _c === void 0 ? PRODUCT_LAYOUTS[0] : _c, children = _a.children;
    var _d = useState(layoutName), productLayoutName = _d[0], setProductLayoutName = _d[1];
    /**
     * If customLayouts are provided they extend the base-layoutConfigs
     */
    var availableProductLayoutConfigs = useMemo(function () { return (__assign(__assign({}, productLayoutConfigCollection), customLayouts)); }, [customLayouts]);
    if (!availableProductLayoutConfigs[layoutName]) {
        // eslint-disable-next-line no-console
        console.error("'" + layoutName + "' not available in productLayoutConfigCollection" + (customLayouts && ' or customLayouts'));
        return null;
    }
    var _e = useState(availableProductLayoutConfigs[layoutName]), productLayoutConfig = _e[0], setProductLayoutConfig = _e[1];
    var selectProductLayoutConfig = useCallback(function (selectedProductLayoutName) {
        setProductLayoutName(selectedProductLayoutName);
        setProductLayoutConfig(availableProductLayoutConfigs[selectedProductLayoutName]);
    }, []);
    useEffect(function () {
        selectProductLayoutConfig(layoutName);
    }, [layoutName]);
    return (React.createElement(ProductLayoutContext.Provider, { value: {
            productLayoutName: productLayoutName,
            productLayoutConfig: productLayoutConfig,
            selectProductLayoutConfig: selectProductLayoutConfig,
        } }, children));
};
export { productLayoutConfigCollection, PRODUCT_LAYOUTS, productLayoutConfigDefault, componentVisibleDefault, };
export default ProductLayoutProvider;
//# sourceMappingURL=index.js.map